<template>
  <div class="about-us-wrapper">
    <div class="journal-top clearfix">
      <div class="jonaral-left">
        <!-- <search></search> -->
      </div>
      <div class="nav-wrapper">
        <span>当前位置：</span>
        <span class="active">纪检监察监督举报</span>
      </div>
    </div>
    <div class="con-center">
      <h3>{{detail.title}}</h3>
      <div class="article-content ql-editor" v-html="detail.content"></div>
    </div>
  </div>
</template>
<script>
import search from "@/components/views/common/search.vue";
import { userApi } from "@/api/user.js";
export default {
  data() {
    return {
      detail:[]
    };
  },
  components: {
    search
  },
  mounted() {
    this.jijianDetail();
  },
  methods: {
    jijianDetail() {
      userApi.jijian({id:1}).then(res => {
        this.detail = res.data
      });
    }
  },
};
</script>

<style scoped>
.about-us-wrapper {
  width: 1240px;
  margin: 0 auto;
}
.jonaral-left {
  width: 310px;
  margin-right: 30px;
  float: left;
}
.nav-wrapper {
  font-size: 0;
  margin-bottom: 30px;
}
.nav-wrapper span {
  font-size: 16px;
  color: #212121;
  line-height: 40px;
}
.active {
  color: #194eb0 !important;
  cursor: pointer;
}
.padd {
  padding: 0 4px;
}
.con-center {
  width: 100%;
  border-width: 20px 1px 20px 1px;
  border-color: #e6ecf2;
  border-style: solid;
  border-radius: 10px;
  padding: 50px 199px;
  box-sizing: border-box;
  text-align: center;
  font-size: 18px;
}
.con-center h3{
  padding-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/conUs/supervise.vue